exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".igx-dialog{display:flex;position:fixed;align-items:center;justify-content:center;top:0;right:0;left:0;bottom:0;background:rgba(0,0,0,.38);z-index:24}.igx-dialog--hidden{display:none}.igx-dialog__window{max-width:25em;min-width:17.5em;padding:.75em 1.5em;border-radius:2px;background:#fff;box-shadow:0 11px 15px -7px rgba(0,0,0,.26),0 24px 38px 3px rgba(0,0,0,.12),0 9px 46px 8px rgba(0,0,0,.08)}.igx-dialog__window-title{color:rgba(0,0,0,.74);font-size:1.25em;line-height:1em;padding-top:.75em;padding-bottom:.625em;font-weight:600}.igx-dialog__window-content{color:rgba(0,0,0,.54);font-size:1em;line-height:1.125em;padding-top:.625em;padding-bottom:.75em}.igx-dialog__window-actions{display:flex;margin:0 -1.5em -.75em;flex-flow:row nowrap;justify-content:flex-end;padding:.5em}.igx-dialog__window-actions button~button{margin-left:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true}!./node_modules/sass-loader/lib/loader.js!./src/dialog/dialog.component.scss
// module id = 52
// module chunks = 0 1